import { jsx as r, jsxs as h } from "react/jsx-runtime";
import t, { useEffect as R } from "react";
import { a as x } from "../chunks/breakpoints.907eaecd.js";
import n, { css as i } from "styled-components";
import { R as L, I as M } from "../chunks/index.cff5baaf.js";
import { d as z, _ as S } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { R as j } from "../chunks/Description.be3b00d1.js";
const u = {
  Completed: "completed",
  Progress: "progress",
  Next: "next",
  Warning: "warning",
  Error: "error"
};
Object.values(u);
const c = {
  Vertical: "vertical",
  Horizontal: "horizontal"
};
Object.values(c);
const _ = {
  completed: "CheckLine",
  warning: "WarningLine",
  error: "NegativeLine",
  next: "",
  progress: ""
}, o = {
  completed: "positive",
  warning: "warning",
  error: "negative",
  next: "",
  progress: "informative"
}, D = n.div.withConfig({
  displayName: "Timeline",
  componentId: "sc-xoo5vc-0"
})(["display:flex;flex-direction:column;", ""], ({
  orientation: e
}) => e === c.Horizontal && i(["", ""], x.md(i(["flex-direction:row;"])))), W = t.forwardRef(({
  children: e,
  orientation: a = c.Vertical,
  ...l
}, p) => {
  const [s, g] = t.useState(e);
  R(() => {
    g(f());
  }, [a, e]);
  const f = () => t.Children.map(e, (d) => t.cloneElement(d, {
    ...d.props,
    orientation: a
  }));
  return /* @__PURE__ */ r(D, { orientation: a, ref: p, "data-testid": "rango-timeline", "data-rango-component": "rango-timeline", "data-is-rango": !0, ...l, children: s });
});
W.displayName = "RangoTimeline";
const b = n.div.withConfig({
  displayName: "MarkerWrapper",
  componentId: "sc-n6690c-0"
})(["display:flex;gap:var(--spacing-half);flex-direction:column;padding-bottom:var(--spacing-half);align-items:center;"]), w = n.div.withConfig({
  displayName: "Marker",
  componentId: "sc-n6690c-1"
})(["", " display:flex;justify-content:center;align-items:center;min-width:var(--size-3x);min-height:var(--size-3x);border-radius:var(--border-radius-circular);background-color:var(--elements-bg-color-02);"], z), m = n.div.withConfig({
  displayName: "Line",
  componentId: "sc-n6690c-2"
})(["border-radius:var(--border-radius-circular);background-color:var(--elements-bg-color-02);width:2px;height:100%;"]), I = n.div.withConfig({
  displayName: "Content",
  componentId: "sc-n6690c-3"
})(["padding-top:var(--spacing-half);padding-bottom:var(--spacing-3x);gap:var(--spacing-1x);display:grid;"]), C = n.span.withConfig({
  displayName: "IconLabel",
  componentId: "sc-n6690c-4"
})(["color:var(--on-text-label-color);"]), E = n.span.withConfig({
  displayName: "Label",
  componentId: "sc-n6690c-5"
})(["", " color:var(--text-label-color);"], S), H = n(j).withConfig({
  displayName: "Description",
  componentId: "sc-n6690c-6"
})(["word-break:break-all;"]), y = n(L).withConfig({
  displayName: "Icon",
  componentId: "sc-n6690c-7"
})([""]), O = n.div.withConfig({
  displayName: "TimelineItem",
  componentId: "sc-n6690c-8"
})(["gap:var(--spacing-2x);display:flex;max-width:180px;width:180px;flex-direction:row;&:last-of-type{", "{display:none;}}", " ", " ", ""], m, ({
  orientation: e
}) => e === c.Horizontal && i(["", ""], x.md(i(["flex-direction:column;", "{flex-direction:row;align-items:center;padding-right:var(--spacing-half);}", "{width:100%;height:2px;}", "{padding-right:var(--spacing-2x);padding-top:0;padding-bottom:0;}"], b, m, I))), ({
  type: e
}) => o[e] && i(["", "{background-color:var(--", "-bg-color-02);}", "{background-color:var(--", "-border-color);}", "{color:var(--on-", "-icon-color);}"], w, o[e], m, o[e], y, o[e]), ({
  type: e
}) => e && o[e] === o.progress && i(["", "{color:var(--on-informative-label-color);}"], C)), V = t.forwardRef(({
  index: e,
  label: a,
  description: l,
  orientation: p = c.Vertical,
  type: s = u.Next,
  ...g
}, f) => {
  const d = () => {
    const v = _[s];
    return v === "" ? /* @__PURE__ */ r(C, { children: e }) : /* @__PURE__ */ r(y, { icon: v, size: M.SM });
  }, N = () => /* @__PURE__ */ h(b, { children: [
    /* @__PURE__ */ r(w, { children: d() }),
    /* @__PURE__ */ r(m, {})
  ] }), T = () => l ? /* @__PURE__ */ r(H, { children: l }) : null, k = () => /* @__PURE__ */ h(I, { children: [
    /* @__PURE__ */ r(E, { children: a }),
    T()
  ] });
  return /* @__PURE__ */ h(O, { orientation: p, type: s, ref: f, ...g, children: [
    N(),
    k()
  ] });
});
V.displayName = "RangoTimelineItem";
export {
  W as RangoTimeline,
  V as RangoTimelineItem,
  c as TimelineOrientation,
  u as TimelineType
};
